import React from 'react';

import {
  t,
} from '../../helpers';

import './Navigation.css';

const Navigation = () => (
  <nav className="navbar navbar-expand-lg navbar-light fixed-top" id="mainNav">
    <div className="container">
      <a className="navbar-brand js-scroll-trigger" href="#header">
        <i className="fa fa-user" />
        <span className="light">{t('navigation.main')}</span>
      </a>
      <button
        className="navbar-toggler navbar-toggler-right"
        type="button"
        data-toggle="collapse"
        data-target="#navbarResponsive"
        aria-controls="navbarResponsive"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        {t('navigation.menu')}
        <i className="fa fa-bars" />
      </button>
      <div className="collapse navbar-collapse" id="navbarResponsive">
        <ul className="navbar-nav ml-auto">
          <li className="nav-item">
            <a className="nav-link js-scroll-trigger" href="#about">{t('navigation.about')}</a>
          </li>
          <li className="nav-item">
            <a className="nav-link js-scroll-trigger" href="#resume">{t('navigation.resume')}</a>
          </li>
          <li className="nav-item">
            <a className="nav-link js-scroll-trigger" href="#photography">{t('navigation.photography')}</a>
          </li>
          <li className="nav-item">
            <a className="nav-link js-scroll-trigger" href="#contact">{t('navigation.contact')}</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
);

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Navigation/index.js